export default "__VITE_ASSET__26c294e5__"